import { useEffect } from 'react';

const SITE_URL = 'https://www.blushandbobby.com';
const BRAND = 'Blush & Bobby';
const DEFAULT_TITLE = `${BRAND} | Bridal Hair & Makeup Artist | Kansas City`;
const DEFAULT_DESC =
  'Award-winning bridal hair and makeup artist serving Kansas City and beyond. Featured on The Knot & Wedding Wire. Book your wedding day beauty services today.';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Updates document <head> tags for the current route. Uses imperative DOM
 * updates (no extra dependency) so each page gets a unique title, description,
 * canonical URL, and social-share metadata for SEO.
 *
 * @param {string} [title] Page-specific title; brand suffix is appended automatically.
 * @param {string} [description] Meta description for the page.
 * @param {string} [path] Route path, e.g. "/services" (defaults to "/").
 * @param {string} [image] Absolute or root-relative OG image URL.
 * @param {boolean} [noindex] When true, asks search engines not to index the page.
 */
export default function Seo({ title, description, path = '/', image, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE_URL}${path}`;
    const img = image
      ? image.startsWith('http')
        ? image
        : `${SITE_URL}${image}`
      : DEFAULT_IMAGE;

    document.title = fullTitle;
    upsertMeta('name', 'description', desc);
    upsertMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
    upsertCanonical(url);

    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', img);

    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
    upsertMeta('name', 'twitter:image', img);
  }, [title, description, path, image, noindex]);

  return null;
}
